module.exports = __webpack_public_path__ + "img/list_blue.909c3634.png";